<template>
  <v-container fill-height>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <template v-for="n in steps">
          <v-stepper-step :complete="e1 > n"
                          :step="n">
          </v-stepper-step>
          <v-divider v-if="n !== steps"
                     :key="n"></v-divider>
        </template>
      </v-stepper-header>
      <v-row>
        <v-col cols="12">
          <v-stepper-items>
            <v-stepper-content v-for="n in steps"
                               :key="`${n}-content`"
                               :step="n">
              <v-row>
                <v-col cols="12">
                  <step1 v-if="n === 1"></step1>
                  <step2 v-else-if="n === 2"></step2>
                  <step3 v-else-if="n === 3"></step3>
                  <step4 v-else-if="n === 4"></step4>
                  <step5 v-else-if="n === 5"></step5>
                  <step6 v-else-if="n === 6" :step="e1"></step6>
                </v-col>
              </v-row>

            </v-stepper-content>
          </v-stepper-items>
        </v-col>
      </v-row>
    </v-stepper>
    <v-footer fixed
              class="font-weight-medium">
      <v-row align="end">
        <v-col cols="6">
          <v-btn text
                 large
                 @click="e1--"
                 v-if="e1 > 1">
            <v-icon>mdi-chevron-left</v-icon>
            ย้อนกลับ
          </v-btn>
        </v-col>
        <v-col cols="6" align="right">
          <v-btn color="primary"
                 text
                 large
                 v-if="(e1 === 1 && isDataStep1)"
                 @click="e1++">
            ต่อไป
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn color="primary"
                 text
                 large
                 v-if="e1 === 2"
                 @click="e1++">
            ต่อไป
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn color="primary"
                 text
                 large
                 v-else-if="e1 === 6 && show"
                 @click="submitParcel()">
            ยืนยัน
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-progress-circular
              indeterminate
              color="primary"
              v-else-if="e1 === 6 && !show">
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import EventBus from '@/EventBus'
import axios from "@/axios";
import axiosMediaCenter from "@/axios_mediaCenter";
import Step1 from '@/components/StepWaiting/Step1'
import Step2 from '@/components/StepWaiting/Step2'
import Step3 from '@/components/StepWaiting/Step3'
import Step4 from '@/components/StepWaiting/Step4'
import Step5 from '@/components/StepWaiting/Step5'
import Step6 from '@/components/StepWaiting/Step6'

export default {
  name: "waiting-parcel",
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
  },
  data() {
    return {
      searchText: '',
      e1: 1,
      steps: 6,
      barcode: '',
      logisticId: '',
      parcelTypeId: '',
      isDataStep1: false,
      isDataStep5: false,
      logisticName: '',
      parcelTypeName: '',
      dataSelect: [],
      lt_runno: '',
      newCus: 'false',
      show: true
    }
  },
  created() {
    this.getLtRunno()
    EventBus.$on('step_submit', params => {
      // console.log('step_submit',params)
      let localItem = this.getLocalItem()
      switch (params.step) {
        case 1:
          this.isDataStep1 = params.isData
          this.barcode = params.barcode
          if (params.barcode) {
            localItem.barcode = params.barcode
          } else {
            delete localItem.barcode
          }
          break;
        case 2:
          localItem.imageUrl = params.imageUrl
          localItem.imageFile = params.imageFile
          break;
        case 3:
          this.logisticId = params.id
          this.logisticName = params.name
          localItem.logisticName = params.name
          this.e1++
          break;
        case 4:
          this.parcelTypeId = params.id
          this.parcelTypeName = params.name
          localItem.parcelTypeName = params.name
          this.e1++
          break;
        case 5:
          this.isDataStep5 = params.isData
          this.dataSelect = params.dataSelect
          this.newCus = params.cus_new
          localItem.dataSelect = params.dataSelect
          this.e1++
          break;
      }
      localStorage.setItem('parcel', JSON.stringify(localItem))
    })
  },
  mounted() {
    window.scrollTo(0, 0)
    EventBus.$emit('set_navigation', {title: 'บันทึกรับพัสดุ', back_route: 'main-menu'});

    let localItem = this.getLocalItem();
    delete localItem.itemSelected;
    delete localItem.itemsParcel;
    delete localItem.searchText;
    delete localItem.QRref;

    delete localItem.dataSelect;
    delete localItem.logisticName;
    delete localItem.parcelTypeName;
    delete localItem.imageUrl;
    // delete localItem.barcode;
    if (localItem.barcode) {
      this.barcode = localItem.barcode
    }

    localStorage.setItem('parcel', JSON.stringify(localItem))
  },
  methods: {
    goto(route_name) {
      return this.$router.push({name: route_name, back_route: 'main-menu'})
    },
    async submitParcel() {
      this.show = false

      let formData = {
        username: this.getLocalItem().user_id,
        nt_runno: this.getLocalItem().nt_runno,
        lt_runno: this.lt_runno,
        su_barcode: this.getLocalItem().barcode,
        su_fullname: this.getLocalItem().dataSelect.cs_fullname,
        st_runno: this.parcelTypeId,
        pd_addr: this.getLocalItem().dataSelect.pd_addr,
        su_phone: this.getLocalItem().dataSelect.cs_mobile,
        su_building: this.getLocalItem().dataSelect.pd_building,
        pl_runno: this.logisticId,
        newCus: this.newCus,
      }

      console.log('submitParcel', formData)

      try {
        axios.post("/SlotSaveParcel", formData).then((res) => {
          console.log('submitParcel', res.data.data)

          let localItem = this.getLocalItem();
          localItem.parcelSaveData = res.data.data
          localStorage.setItem('parcel', JSON.stringify(localItem))

          if (this.getLocalItem().imageUrl) {
            let block = this.getLocalItem().imageUrl.split(";");
            let contentType = block[0].split(":")[1];
            let realData = block[1].split(",")[1];

            let blob = this.b64toBlob(realData, contentType);
            this.uploadImgWaiting(blob);
          } else {
            this.goto('save-success');
          }

        });
      } catch (err) {
        console.log("submitParcel", err.message);
      }
    },
    async getLtRunno() {
      try {
        axios.post("/GetLotParcel", {
          username: this.getLocalItem().user_id,
          nt_runno: this.getLocalItem().nt_runno,
        }).then((res) => {
          this.lt_runno = res.data.data.LT_RUNNO
          // console.log('getLtRunno',res.data.data.LT_RUNNO)
        });
      } catch (err) {
        console.log("getLtRunno", err.message);
      }
    },
    async uploadImgWaiting(blob) {
      let bodyFormData = new FormData();
      bodyFormData.set("file_upload", blob);
      bodyFormData.set("disk", "asset");
      bodyFormData.set("path", "Parcel\\Waiting\\" + this.getLocalItem().nt_code);
      try {
        axiosMediaCenter.post("/upload", bodyFormData).then(res => {
          console.log("uploadImgWaiting", res.data.data);
          this.savePicturePath(res.data.data);
          this.goto('save-success');
        });
      } catch (err) {
        console.log(err.message);
      }
    },
    async savePicturePath(data) {
      let formData = {
        username: this.getLocalItem().user_id,
        su_runno: this.getLocalItem().parcelSaveData[0].SU_RUNNO,
        path: data.url,
      }
      console.log('SavePicturePath', formData)
      try {
        axios.post("/SavePicturePath", formData).then((res) => {
          console.log('SavePicturePath', res.data.data)
        });
      } catch (err) {
        console.log("getLtRunno", err.message);
      }
    },
  },
  watch: {
    e1: function (val) {
      if (val) {
        EventBus.$emit('this_step', val)
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.v-stepper {
  height: 100%;
  width: 100%;
}
</style>
